import { render, staticRenderFns } from "./DisplayBanner.vue?vue&type=template&id=05308493"
import script from "./DisplayBanner.vue?vue&type=script&lang=js"
export * from "./DisplayBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports